import { render } from "./UI.vue?vue&type=template&id=c4fcc436"
import script from "./UI.vue?vue&type=script&lang=js"
export * from "./UI.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__